
import React from "react";
import * as Hooks from "../../../../../hooks";
import { i18nManager } from "../../../../../i18n";
import { Schemes, Utils } from "../../../../../utils";
import { ConfirmDialog } from "../../../../shared/ConfirmDialog";
import { Button, FileHelper, Form, useSubscription } from "@rivtn/noseur";
import { CreateTournamentSectionProps, CreateTournamentSection } from "../CreateTournament";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";
import { BaseService, ConsusService, IUploadedFile, SanitizedResponse } from "../../../../../services";
import { Elements } from "../../../../shared/Elements";

function Media(props: CreateTournamentSectionProps) {

    const { active, tournamentEditionState } = props;
    const [themeMode, _] = Hooks.useThemeMode();
    const consusService = ConsusService.getInstance();
    const [tournament, setTournament] = tournamentEditionState;
    const logoMediaInputManageRef = React.useRef<MediaInputManageRef>(null);
    const bannerMediaInputManageRef = React.useRef<MediaInputManageRef>(null);
    const labels = i18nManager.Labels.host.create_tournament.media;

    return (<div className="create-tournament-f flow details" ref={props.ref}>
        {!active && (<div className="overlay" onClick={() => props.setActiveSection(CreateTournamentSection.MEDIA, undefined, true)} />)}
        <span className="title">{"Media"}</span>
        <Form className="content" scheme={Schemes.OMNEHOST}>
            <MediaInput width={"100%"} height={180} extraControls={<div className={"noseur-file-input-label"} onClick={selectProgramBanner}><i className='fa fa-gamepad' /></div>}
                default={tournament?.banner_url} manageRef={bannerMediaInputManageRef} noFillTemplate onSelectFiles={(files) => {
                    consusService.uploadFile(`/omnehost/tournament/`, `${tournament.external_id}_banner`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                        setTournament({ ...tournament, banner_url: sanitized.consus_download_url });
                    }).catch(BaseService.reportError);
                }} onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} />
            <MediaInput width={180} height={180} style={{ borderRadius: "100%", margin: "auto", marginTop: -80 }}
                extraControls={<div className={"noseur-file-input-label"} onClick={selectProgramIcon}><i className='fa fa-gamepad' /></div>}
                default={tournament?.logo_url} manageRef={logoMediaInputManageRef} noFillTemplate onSelectFiles={(files) => {
                    consusService.uploadFile(`/omnehost/tournament/`, `${tournament.external_id}_logo`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                        setTournament({ ...tournament, logo_url: sanitized.consus_download_url });
                    }).catch(BaseService.reportError);
                }} onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} />
            <p style={{ marginTop: 20 }}>{labels.note_can_add_more}</p>
            <p style={{ marginTop: -10, color: "#FF7171" }}>{labels.note_selected_media_copyright.replaceAll("${copyright}", tournament?.program?.copyright ?? "Unknown")}</p>
        </Form>
        <div className="controls">
            <Button textOnly scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.prev} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.PROGRAM_AND_PARTICIPANT, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
            <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.next} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.DATES, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
        </div>
    </div>);

    function selectProgramBanner() {
        const dialog = ConfirmDialog({
            closable: true,
            noControl: true,
            dismissibleModal: true,
            style: { maxWidth: "90%" },
            content: (<div className="popup-select-media-container">
                <div className="header">
                    <span className="t">{labels.select_program_banner}</span>
                    <i className="fa fa-close" onClick={() => dialog.hide()} />
                </div>
                <div className="popup-select-media banner">
                    {tournament?.program?.banner_urls?.map((src) => (<img key={src} alt={src} src={src} onClick={async () => {
                        dialog.hide();
                        bannerMediaInputManageRef.current?.changeFiles([await Utils.getFileFromUrl(src, "banner")]);
                    }} />))}
                </div>
            </div>)
        });
        dialog.show();
    }

    function selectProgramIcon() {
        const dialog = ConfirmDialog({
            closable: true,
            noControl: true,
            dismissibleModal: true,
            style: { maxWidth: "90%" },
            content: (<div className="popup-select-media-container">
                <div className="header">
                    <span className="t">{labels.select_program_icon}</span>
                    <i className="fa fa-close" onClick={() => dialog.hide()} />
                </div>
                <div className="popup-select-media logo">
                    {tournament?.program?.logo_urls?.map((src) => (<img key={src} alt={src} src={src} onClick={async () => {
                        dialog.hide();
                        logoMediaInputManageRef.current?.changeFiles([await Utils.getFileFromUrl(src, "logo")]);
                    }} />))}
                </div>
            </div>)
        });
        dialog.show();
    }

}

export default Media;
